export enum Constants {
  SET_MAP_COORDINATE = "SET_MAP_COORDINATE",
  SET_MAP_INFO = "SET_MAP_INFO",
}
